import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import './aboutus.css';

const PrivacyPolicy = () => {
  const [formData, setFormData] = useState({
    id: 1,
    title: '',
    description: '',
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('http://187.124.157.146:5001/api/policies/privacy-policy')
      .then(res => {
        const data = res.data;
        setFormData({
          id: data.id,
          title: data.title || '',
          description: data.description || '',
        });
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching privacy policy:", err);
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditorChange = (content) => {
    setFormData(prev => ({
      ...prev,
      description: content
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = sessionStorage.getItem('authToken');

      await axios.put(
        `http://187.124.157.146:5001/api/policies/privacy-policy/${formData.id}`,
        {
          title: formData.title,
          description: formData.description
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      alert('Privacy Policy updated successfully!');
    } catch (error) {
      console.error("Error updating privacy policy:", error.response?.data || error.message);
      alert('Error updating privacy policy');
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto aboutus">
      <h2 className="text-xl font-bold mb-4">Update Privacy Policy</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="block mb-1">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="border p-2 w-full"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block mb-1">Description</label>
            <Editor
              apiKey="ewqu5ti6bsjbxirh6rptpf3m05mwek075mt56suan91l8exv"  
              value={formData.description}
              onEditorChange={handleEditorChange}
              init={{
                height: 400,
                menubar: true,
                plugins: [
                  'advlist autolink lists link image charmap preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table code help wordcount'
                ],
                toolbar:
                  'undo redo | formatselect | bold italic underline | ' +
                  'alignleft aligncenter alignright alignjustify | ' +
                  'bullist numlist outdent indent | image media link | removeformat | help',
                automatic_uploads: true,
                image_title: true,
                file_picker_types: 'image',
                file_picker_callback: (cb) => {
                  const input = document.createElement('input');
                  input.setAttribute('type', 'file');
                  input.setAttribute('accept', 'image/*');
                  input.onchange = function () {
                    const file = this.files[0];
                    const reader = new FileReader();
                    reader.onload = function () {
                      cb(reader.result, { title: file.name });
                    };
                    reader.readAsDataURL(file);
                  };
                  input.click();
                }
              }}
            />
          </div>

          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded mt-3 btn btn-primary btn-set-task w-sm-100 text-uppercase px-5"
          >
            Update
          </button>
        </form>
      )}
    </div>
  );
};

export default PrivacyPolicy;
